import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import moment from 'moment'
import { store } from './store/store'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VeeValidate from "vee-validate";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'admin-lte/plugins/fontawesome-free/css/all.css'
import 'admin-lte/dist/css/alt/adminlte.plugins.css'
import 'admin-lte/dist/css/adminlte.css'
import 'admin-lte/plugins/jquery/jquery.js'
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import 'admin-lte/dist/js/adminlte.js'
import IdleVue from "idle-vue";
import './helper/globalDropDown'

//import './registerServiceWorker'

Vue.config.productionTip = false

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 600000, // 10 minutes,
  startAtIdle: false
});
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});

Vue.use(VeeValidate);
Vue.use(Loading)
Vue.use(BootstrapVue)
Vue.config.devtools = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})
Vue.filter('formatBirthDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY')
  }
})
Vue.filter('soiDate', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM Do YYYY, h:mm:ss a')
  }
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  return value.toUpperCase()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
